import styled from 'styled-components'

export const StyledTextAreaLabelWrapper = styled.label`
    display: block;
    margin-bottom: 20px;
`

export const StyledTextAreaLabel = styled.div`
    margin-bottom: 10px;
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.5px;
    color: ${({ theme }) => theme.greyishBrown};
`

export const StyledTextArea = styled.textarea`
    width: 100%;
    min-height: 160px;
    padding: 10px;
    border: 1px solid ${ ({ theme, error }) => error ? theme.pastelRed : theme.veryLightPink};
    border-radius: 6px;
    font-size: 14px;
    &::placeholder {
        color: ${({ theme }) => theme.lightPeach};
    }
`

export const StyledTextAreaError = styled.div`
    margin-bottom: 20px;
    color: ${ ({ theme }) => theme.pastelRed};
`